import React from "react";
import { Route, Switch } from "react-router-dom";

import { useShowMavenWidget } from "../Common/mavenChatUtils";
import RegisterUpdated from "../RegistrationUpdated/RegistrationUpdated";

import { RegistrationContextProvider } from "./Components/Common/registrationContext";
import { REGISTRATION_PATHS } from "./Components/Common/service";
import RegistrationCalendly from "./Components/RegistrationCalendly/RegistrationCalendly";
import RegistrationEducation from "./Components/RegistrationEducation/RegistrationEducation";
import RegistrationHireflix from "./Components/RegistrationHireflix/RegistrationHireflix";
import RegistrationLicense from "./Components/RegistrationLicense/RegistrationLicense";
import RegistrationLocation from "./Components/RegistrationLocation/RegistrationLocation";
import RegistrationReferral from "./Components/RegistrationReferral/RegistrationReferral";
import RegistrationSignUp from "./Components/RegistrationSignUp/RegistrationSignUp";
import { RegistrationVetPreferences } from "./Components/RegistrationVetPreferences/RegistrationVetPreferences";
import { RegistrationMeetYourRooRep } from "./Components/RegistrationMeetYourRooRep/RegistrationMeetYourRooRep";
import { RegistrationWhyAreYouOnRoo } from "./Components/RegistrationWhyAreYouOnRoo/RegistrationWhyAreYouOnRoo";
import { RegistrationContinue } from "./RegistrationContinue";

export const RegistrationNew = () => {
  useShowMavenWidget(false);

  return (
    <RegistrationContextProvider>
      <Switch>
        <Route path={REGISTRATION_PATHS.Continue} component={RegistrationContinue} />
        <Route path={REGISTRATION_PATHS.Referral} component={RegistrationReferral} />
        <Route path={REGISTRATION_PATHS.Hireflix} component={RegistrationHireflix} />
        <Route path={REGISTRATION_PATHS.Calendly} component={RegistrationCalendly} />
        <Route path={REGISTRATION_PATHS.Education} component={RegistrationEducation} />
        <Route path={REGISTRATION_PATHS.License} component={RegistrationLicense} />
        <Route path={REGISTRATION_PATHS.WhyAreYouOnRoo} component={RegistrationWhyAreYouOnRoo} />
        <Route path={REGISTRATION_PATHS.VetPreferences} component={RegistrationVetPreferences} />
        <Route path={REGISTRATION_PATHS.MeetRooRep} component={RegistrationMeetYourRooRep} />
        <Route path={REGISTRATION_PATHS.Location} component={RegistrationLocation} />
        <Route path={REGISTRATION_PATHS.SignUp} component={RegistrationSignUp} />
        <Route path={REGISTRATION_PATHS.Landing} component={RegisterUpdated} />
      </Switch>
    </RegistrationContextProvider>
  );
};

// eslint-disable-next-line no-restricted-exports
export default RegistrationNew;
